import React, { Component } from "react";
import styled from "styled-components";
import { Route } from "react-router-dom";
import jwt from "jsonwebtoken";

// Context //
import ChatContext from "context/ChatContext";

// Screens //
import Step1 from "./views/Step1";
import Step2 from "./views/Step2";
import Step3 from "./views/Step3";
import Step4 from "./views/Step4";
import Step5 from "./views/Step5";
import Step6 from "./views/Step6";
import Step7 from "./views/Step7";

// Components //
import Pagination from 'components/Pagination';
import View from "components/View";
import Chat from "components/Chat";

const Root = styled(View)`
  margin: 0 auto;
  width: 100%;
  max-width: 1256px;
  flex-direction: row;
  clear: both;
  flex: 1;
`;

const PaginationWrapper = styled(View)`
  width: 80px;
  padding-top: 80px;
  justify-content: flex-start;
  align-items: flex-end;
  position: fixed;
  z-index: 2;
  @media screen and (max-width: 892px ) {
    align-items: flex-start;
    padding-left: 15px;
  }
`;

const TutorialWrapper = styled(View)`
  flex: 1 0 400px;
`;

const StepWrapper = styled(View)`
  max-width: 672px;
  padding: 40px 40px 40px 120px;
  @media screen and (max-width: 892px ) {
    max-width: 400px;
    padding: 40px 0 40px 50px;
  }
`;

const ChatWrapper = styled(View)`
  float: right;
  justify-content: flex-start;
  align-items: center;
  width: 400px;
  padding: 40px;
  right: 0;
  z-index: 2;
  @media screen and (max-width: 892px ) {
    width: 400px;
    float: unset;

  }
`;

const FixedWrapper = styled(View)`
  position: fixed;
`;

// Constants //
// TODO: Move to server env
const token = jwt.sign(
  { user_id: "jon-snow" },
  "vz4yhgcwums5h64uh8xbx58c9yfgtkjneab5ch9skds93xzqd8mv6dc824dusnvt"
);

class GettingStartedScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token,
      client: null,
      channel: null,
      completedSteps: [],
      messageId: null,
      setClient: this._setClient.bind(this),
      setChannel: this._setChannel.bind(this),
      setMessageId: this._setMessageId.bind(this),
      setStepComplete: this._setStepComplete.bind(this)
    };
  }

  _setClient = async client => {
    await this.setState({
      client
    });
  };

  _setChannel = async channel => {
    await this.setState({
      channel
    });
  };

  _setMessageId = async messageId => {
    await this.setState({
      messageId
    });
  };

  _setStepComplete = async step => {
    let { completedSteps } = this.state;

    completedSteps.push(step);
    await this.setState({
      completedSteps
    })
  }

  render() {
    const { match } = this.props;
    const { completedSteps } = this.state;
    return (
      <ChatContext.Provider value={this.state}>
        <Root>
          <PaginationWrapper>
            <Pagination
              completedSteps={completedSteps}
              step={match.params.step}
              items={[
                '/step-1',
                '/step-2',
                '/step-3',
                '/step-4',
                '/step-5',
                '/step-6',
                '/step-7',
              ]}
            />
          </PaginationWrapper>
          <TutorialWrapper>
            <StepWrapper>
              <Route path="/step-1" component={Step1} />
              <Route path="/step-2" component={Step2} />
              <Route path="/step-3" component={Step3} />
              <Route path="/step-4" component={Step4} />
              <Route path="/step-5" component={Step5} />
              <Route path="/step-6" component={Step6} />
              <Route path="/step-7" component={Step7} />
            </StepWrapper>
          </TutorialWrapper>
          <ChatWrapper>
            <FixedWrapper>
              <Chat />
            </FixedWrapper>
          </ChatWrapper>
        </Root>
      </ChatContext.Provider>
    );
  }
}

export default GettingStartedScreen;
